import React, { forwardRef } from 'react';

import { ReactComponent as CloseIcon } from '../../../icons/close.svg';
import { ReactComponent as SearchIcon } from '../../../icons/search.svg';

import { Input } from '../input/Input';

export const SearchInput = forwardRef(
  ({ label, name, value, placeholder, onChange, style }, ref) => {
    return (
      <Input
        label={label}
        name={name}
        type="text"
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        clearIcon={CloseIcon}
        icon={SearchIcon}
        style={style}
        filled
        className="search-input"
      />
    );
  }
);
